// extracted by mini-css-extract-plugin
export var pillWrapper = "_q0-0";
export var showOverflow = "_q0-1";